import { graphql } from "react-relay";
import { ChromeEventSuggestedTimes } from "./ChromeEventSuggestedTimes";

export const query = graphql`
  query ChromeEventSuggestedTimesRendererQuery(
    $orgRelayId: ID!
    $reschedulerExternalEventId: String!
    $reschedulerTimeZone: String!
    $reschedulerRangeMin: DayTimeSlotInput!
    $reschedulerRangeMax: DayTimeSlotInput!
  ) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        ...ChromeEventSuggestedTimes_org
        reschedulingResponseErrorable(
          externalEventId: $reschedulerExternalEventId
          timeZone: $reschedulerTimeZone
          rangeMin: $reschedulerRangeMin
          rangeMax: $reschedulerRangeMax
        ) {
          ...ChromeEventSuggestedTimes_schedulingResponseErrorable
        }
      }
    }
  }
`;
